import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Drawer from '@base/Drawer/DrawerWithFooter';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import RadioButton from '@base/RadioButton/RadioButton';
import { Spacings } from '@styles/index';
import { noOp } from '@constants/empty';

const StyH3 = styled(H3)`
  grid-column: span 10;
  margin-bottom: ${({ $subHeading }) =>
    $subHeading ? Spacings.SPACING_3B : Spacings.SPACING_8B};
  margin-top: ${({ $hideCloseButton }) =>
    !$hideCloseButton ? Spacings.SPACING_4B : Spacings.SPACING_8B};
`;
const StyP1 = styled(P1)`
  grid-column: span 10;
  margin-bottom: ${Spacings.SPACING_6B};
  color: var(--color-text-secondary);
`;

const RadioWrapper = styled.div`
  border: ${({ $checked }) =>
    $checked
      ? `${Spacings.SPACING_1} solid var(--color-base-fill)`
      : `${Spacings.SPACING_1} solid var(--color-divider)`};
  grid-column: span 10;
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_3B};
  ${({ $color }) => ($color ? `color : ${$color};` : '')}
  cursor: pointer;
`;

const RadioList = ({
  mainHeading,
  subHeading,
  list,
  needFooter,
  isDrawerOpen,
  selectedItemUID,
  onChange,
  footer,
  hideCloseButton,
  openDrawer,
  color
}) => {
  const renderList = list.map((item) => {
    const checked = selectedItemUID === item.id;
    return (
      <RadioWrapper
        key={item.id}
        $checked={checked}
        $color={color}
        onClick={() => onChange(item.id)}
      >
        <RadioButton
          checked={checked}
          onChange={() => onChange(item.id)}
          label={item.name}
          key={item.id}
        />
      </RadioWrapper>
    );
  });
  const onCloseDrawer = () => {
    if (!hideCloseButton) openDrawer(false);
  };

  return (
    <Drawer
      drawerState={isDrawerOpen}
      footer={needFooter ? footer : null}
      hideCloseButton={hideCloseButton}
      onClose={onCloseDrawer}
    >
      <StyH3 $hideCloseButton={hideCloseButton} $subHeading={!!subHeading}>
        {mainHeading}
      </StyH3>
      {subHeading && <StyP1>{subHeading}</StyP1>}
      {renderList}
    </Drawer>
  );
};

export default RadioList;

RadioList.propTypes = {
  mainHeading: PropTypes.string,
  subHeading: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.any),
  needFooter: PropTypes.bool,
  isDrawerOpen: PropTypes.bool,
  openDrawer: PropTypes.func,
  selectedItemUID: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func,
  footer: PropTypes.elementType,
  hideCloseButton: PropTypes.bool,
  color: PropTypes.string
};

RadioList.defaultProps = {
  list: [],
  mainHeading: '',
  subHeading: '',
  needFooter: false,
  isDrawerOpen: false,
  openDrawer: noOp,
  selectedItemUID: {},
  onChange: noOp,
  footer: null,
  hideCloseButton: false,
  color: ''
};
